/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NftPurchaseStatus,
    NftPurchaseStatusFromJSON,
    NftPurchaseStatusFromJSONTyped,
    NftPurchaseStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface NftPurchaseLog
 */
export interface NftPurchaseLog {
    /**
     * 
     * @type {number}
     * @memberof NftPurchaseLog
     */
    date: number;
    /**
     * 
     * @type {NftPurchaseStatus}
     * @memberof NftPurchaseLog
     */
    status: NftPurchaseStatus;
}

export function NftPurchaseLogFromJSON(json: any): NftPurchaseLog {
    return NftPurchaseLogFromJSONTyped(json, false);
}

export function NftPurchaseLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftPurchaseLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'status': NftPurchaseStatusFromJSON(json['status']),
    };
}

export function NftPurchaseLogToJSON(value?: NftPurchaseLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'status': NftPurchaseStatusToJSON(value.status),
    };
}


